import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'
import { dateFormat, ppfDateFormat } from '../../../consts'
import MaterialInput from '../MaterialInput'

import './DatePicker.css'

const DatePicker = props => {
  const [day, setDay] = useState('')
  const [month, setMonth] = useState('')
  const [year, setYear] = useState('')
  const dateInput = useRef()
  const yearInput = useRef()
  const { setSelectedDate, className = '', isFromPPF = false } = props

  const isEmpty = str => {
    if (str.trim() === '') {
      return true
    } else {
      return false
    }
  }

  useEffect(() => {
    if (!isEmpty(day) && !isEmpty(month) && !isEmpty(year)) {
      if (isFromPPF) {
        setSelectedDate(
          moment(`${month}/${day}/${year}`).format(ppfDateFormat.dob)
        )
      } else {
        setSelectedDate(
          moment(`${month}/${day}/${year}`).format(dateFormat.dob)
        )
      }
    } else {
      setSelectedDate(null)
    }
  }, [day, month, year])
  const handleMonthChange = event => {
    let mm = event.target.value
    if (mm >= 0 && mm <= 12) {
      setMonth(mm)
      if (mm.length >= 2) {
        dateInput.current.focus()
      }
    }
  }
  const handleDateChange = event => {
    let dd = event.target.value
    if (dd >= 0 && dd <= 31) {
      setDay(dd)
      if (dd.length >= 2) {
        yearInput.current.focus()
      }
    }
  }
  const handleYearChange = event => {
    let year = event.target.value
    if (year >= 0 && year.length <= 4) {
      setYear(year)
    }
  }
  return (
    <div className={'picker-container date-input ' + className}>
      <MaterialInput
        type={'number'}
        label={'MM'}
        value={month}
        className="month-input"
        onChange={handleMonthChange}
      />
      <MaterialInput
        type={'number'}
        label={'DD'}
        ref={dateInput}
        value={day}
        className="day-input"
        onChange={handleDateChange}
      />
      <MaterialInput
        type={'number'}
        label={'YYYY'}
        ref={yearInput}
        className="year-input"
        value={year}
        onChange={handleYearChange}
      />
    </div>
  )
}

export default DatePicker
